import axios from 'axios';

// URL base da API - altere conforme o ambiente
export const API_URL = import.meta.env.VITE_API_URL || 'http://localhost:4000/api';

// Criar instância do axios com configurações padrão
const api = axios.create({
  baseURL: API_URL,
  timeout: 30000,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Interceptor para requisições
api.interceptors.request.use(
  (config) => {
    // Adicionar token de autenticação
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    // Adicionar companyId selecionada pelo master (do contexto)
    // Isso permite que o master visualize dados de uma empresa específica
    const selectedCompanyId = localStorage.getItem('selectedCompanyId');
    if (selectedCompanyId) {
      config.headers['X-Selected-Company-ID'] = selectedCompanyId;
    }

    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Interceptor para respostas
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      // Token expirado ou inválido - só redirecionar se não estiver em /billing
      if (window.location.pathname !== '/billing' && window.location.pathname !== '/login') {
        localStorage.removeItem('token');
        localStorage.removeItem('user');
        window.location.href = '/login';
      }
    }
    
    // Para erros 403 relacionados a assinatura bloqueada, disparar evento para atualizar estado
    if (error.response?.status === 403) {
      const errorData = error.response.data;
      if (errorData?.code === 'SUBSCRIPTION_SUSPENDED' || 
          errorData?.code === 'COMPANY_SUSPENDED' || 
          errorData?.code === 'TRIAL_EXPIRED' ||
          errorData?.code === 'COMPANY_BLOCKED' ||
          errorData?.mustPay ||
          errorData?.blocked) {
        // Disparar evento para atualizar estado de bloqueio imediatamente
        window.dispatchEvent(new CustomEvent('blockedAccess', { detail: errorData }));
        window.dispatchEvent(new CustomEvent('subscriptionUpdated'));
        
        // Salvar informação de bloqueio no localStorage para acesso imediato
        localStorage.setItem('subscriptionBlocked', 'true');
        if (errorData.subscription || errorData.status) {
          if (errorData.subscription) {
            localStorage.setItem('blockedSubscription', JSON.stringify(errorData.subscription));
          } else {
            localStorage.setItem('blockedSubscription', JSON.stringify({ status: errorData.status || 'suspended' }));
          }
        }
      }
    }
    
    // Retornar o erro para ser tratado pelo componente
    return Promise.reject(error);
  }
);

export default api;


